<template>
  <div class="pa-4">
    <v-skeleton-loader v-if="loading" class="mx-auto" type="card"></v-skeleton-loader>
    <div v-else-if="document">
      <v-card-title v-if="document.template">{{ document.template.name }}</v-card-title>
      <v-card-title v-if="document.user" class="mb-0 pb-0">
        <v-avatar v-if="document.user.userImageSmall" size="20">
          <v-img style="width:100px" :src="userFile(document.user.userImageSmall)" />
        </v-avatar>
        <span class="ml-1">{{ document.user.displayName }}</span>
        <span class="supporting-text" style="margin-left:5px">{{ $d(new Date(document.time), "long",
          $i18n.locale) }}</span>
      </v-card-title>
      <v-card-title v-if="document.guardianUser" class="text-caption gray--text mt-0 pt-0">
        <v-avatar v-if="document.guardianUser.userImageSmall" size="20">
          <v-img style="width:100px" :src="userFile(document.guardianUser.userImageSmall)" />
        </v-avatar>
        <span class="ml-1">{{ $t('message.completed_by') }}:</span>
        <span class="ml-1">{{ document.guardianUser.displayName }}</span>
      </v-card-title>
      <v-card elevation="0" outlined>
        <v-card-text v-html="document.contents"></v-card-text>
        <div v-if="document && document.answers">
          <template v-for="(i, index) in document.answers">
            <v-card :key="'question_' + index" class="elevation-0 question-card">
              <v-card-title class="text-subtitle-1">{{ index + 1 }} - {{ i.question }}
                <span class="required ml-1" v-if="i.required"><b>*</b></span></v-card-title>
              <v-card-text class="mt-0 pt-0">
                <span class="supporting-text" v-if="!i.answer && typeof i.answerBoolean == 'undefined'">N/A</span>
                <span class="supporting-text" v-else-if="!i.answer">{{ i.answerBoolean ? $t('message.true') :
                  $t('message.false') }}</span>
                <span class="supporting-text page-description" v-else>{{ i.answer }}</span>
              </v-card-text>
            </v-card>
          </template>
        </div>
        <v-card-text>
          <v-text-field v-if="document.userName" disabled :label="$t('message.name')"
            v-model="document.userName"></v-text-field>
          <v-text-field v-if="document.guardianName" disabled :label="$t('message.guardian')"
            v-model="document.guardianName"></v-text-field>
          <div v-if="document.extraFieldValues">
            <template v-for="(field, index) in document.extraFieldValues">
              <v-text-field disabled :key="'extra_field_' + index" :label="field.fieldName"
                v-model="field.value"></v-text-field>
            </template>
          </div>
        </v-card-text>
        <div class="text-center pa-2" v-if="document.signature">
          <img :src="document.signature" style="height:150px;border-bottom: 1px solid black" />
          <div style="width:700px;margin-right:auto; margin-left:auto">{{ $t('message.signature') }}</div>
        </div>
      </v-card>
      <v-card-actions>
        <v-btn elevation="0" small @click="goBack()">{{ $t('message.back') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" small @click="print(document)">
          <v-icon class="mr-1">
            mdi-printer-outline
          </v-icon>
          {{ $t('message.print') }}</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Api from '@/services/Api';
import { Environment } from "@/services/Environment";

export default {
  data() {
    return {
      documentId: this.$route.params.documentId,
      loading: true,
      document: null,
    };
  },
  components: {
  },
  created() {
    if (this.documentId) {
      Api().get('documents/managedAcademy/' + this.$store.state.managedAcademy + '/completed/' + this.documentId)
        .then(response => {
          if (response) {
            this.document = response.data.document;
            this.loading = false;
          }
        }).catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    }
  },
  watch: {

  },
  methods: {
    print(item) {
      window.open(Environment.get("VUE_APP_ASSETS_HOME") + "secure/printwaiver/" + item._id, "_blank");
    },
  }
};
</script>

<style scoped>
.waiver {
  font-family: 'Bradley Hand';
  color: black
}
</style>
